import { Box, Button, Divider, styled, Typography } from '@mui/material'
import React from 'react'

const TtileTypography = styled(Typography)(({theme}) => ({
  color: '#242424',
  fontSize: '1.4rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.2rem'
  }
}))

const InfoTypography = styled(Typography)(({theme}) => ({
  color: 'black',
  fontSize: '0.9rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem'
  }
}))

const StyledButton = styled(Button)(({theme}) => ({
  fontSize: '0.9rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem'
  }
}))

function ReportsCard({ Title, Info }) {
  return (
    <Box sx={{ m: 2, gap: 1, display: 'flex', flexDirection: 'column', alignItems: 'start', textAlign: 'left', fontFamily: 'sans-serif' }}>
        <TtileTypography>{Title}</TtileTypography>
        <InfoTypography>{Info}</InfoTypography>
        <StyledButton sx={{ p: 0 }} >Read More >></StyledButton>
        <Divider variant="fullWidth" flexItem sx={{ bgcolor: 'grey' }} />
    </Box>
  )
}

export default ReportsCard
